export function getAll() {
  let items = [
    {
      value: 1,
      name: "Food",
      text: "商品",
      url: "Download/Food.svg",
    },
    {
      value: 2,
      name: "Taste",
      text: "口味",
      url: "Download/Taste.svg",
    },
    {
      value: 3,
      name: "Employee",
      text: "員工",
      url: "Download/Employee.svg",
    },
    {
      value: 5,
      name: "Invisible",
      text: "商品隱藏",
      url: "Download/Invisible.svg",
    },
    {
      value: 6,
      name: "Function",
      text: "功能",
      url: "Download/Function.svg",
    },
    {
      value: 7,
      name: "Pay",
      text: "付款方式",
      url: "Download/Pay.svg",
    },
    {
      value: 8,
      name: "Directory",
      text: "科目",
      url: "Download/Directory.svg",
    },
    {
      value: 9,
      name: "Combo",
      text: "套餐",
      url: "Download/Combo.svg",
    },
    {
      value: 10,
      name: "Authority",
      text: "權限",
      url: "Download/Authority.svg",
    },
    {
      value: 11,
      name: "Sequence",
      text: "商品順序",
      url: "Download/Sequence.svg",
    },
    {
      value: 12,
      name: "Promotion",
      text: "促銷",
      url: "Download/Promotion.svg",
    },
    {
      value: 13,
      name: "Label",
      text: "價格標",
      url: "Download/Label.svg",
    },
    {
      value: 14,
      name: "Account",
      text: "帳戶",
      url: "Download/Account.svg",
    },
    {
      value: 15,
      name: "Warehouse",
      text: "倉庫",
      url: "Download/Warehouse.svg",
    },
    {
      value: 16,
      name: "TableMap",
      text: "桌位",
      url: "Download/Combo.svg",
    },
    {
      value: 17,
      name: "KDS",
      text: "KDS",
      url: "Download/KDS.svg",
    },
    {
      value: 18,
      name: "TableMap",
      text: "自訂菜單",
      url: "Download/Combo.svg",
    },
    {
      value: 19,
      name: "Pickup",
      text: "取貨方式",
      url: "Download/Pickup.svg",
    },
    {
      value: 20,
      name: "Nationality",
      text: "國籍",
      url: "Download/Flag.svg",
    },
  ];
  return items;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
